export default "__VITE_ASSET__BOHPMk58__"